module.exports = __webpack_public_path__ + "static/media/muam.66ac06a7.png";